module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-38-36-300.240b6921.mp4";